import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService, UserService } from '../api';
import { tap, filter, switchMap, take, timeout, catchError, of } from 'rxjs';
import { map } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { Account } from '../models/account.model';

export const planGuard: CanActivateFn = (route) => {
  const accountService = inject(AccountService);
  const userService = inject(UserService);
  const router = inject(Router);
  const accountId = route.paramMap.get('accountId');

  if (!accountId) {
    return false;
  }

  // Wait for the token to be available before making the API call - handles the case when user enters the workspace directly from the url
  // Add 3 second timeout to prevent hanging
  return toObservable(userService.token).pipe(
    filter((token) => token !== null), // Wait until token is available
    take(1), // Take only the first non-null token
    timeout(3000), // 3 second timeout
    switchMap(() => accountService.getAccountById(accountId)),
    map((account: Account) => account.active),
    tap((active) => {
      if (!active) {
        router.navigate(['/dashboard']);
      }
    }),
    catchError(() => {
      // If timeout or any other error occurs, redirect to dashboard
      router.navigate(['/dashboard']);
      return of(false);
    }),
  );
};
